import React from 'react';
import PropTypes from 'prop-types';

import AppsListItemSideload from './AppsListItemSideload';
import AppsListItemSuggestion from './AppsListItemSuggestion';
import RenderApps from './RenderApps';

function integrationsApps(props) {
    const apps = props.apps
        .filter((app) => app.featuredOrder === -1)
        .filter((app) => ['egnyte_ui', 'web', 'egnyte_source'].includes(app.type));

    return (
        apps.length > 0 && (
            <div name="integrations-apps">
                <h4 className="appsListItems-title">All Add-ons &amp; Integrations</h4>
                <div className="appsListItemsWrapper">
                    <RenderApps apps={apps} />
                    <AppsListItemSuggestion />
                    <AppsListItemSideload />
                </div>
            </div>
        )
    );
}
integrationsApps.propTypes = {
    apps: PropTypes.array,
};
export default integrationsApps;
